<template>
  <section id="testimonials" class="w-full p-8 bg-gray-600 font-poppins">
    <h2 class="text-4xl font-bold text-center mb-8 text-white py-5">Depoimentos</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
      <div
        v-for="(testimonial, index) in testimonials"
        :key="index"
        class="p-6 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
      >
        <blockquote class="text-gray-800 italic text-base md:text-lg">
          "{{ testimonial.message }}"
        </blockquote>
        <footer class="mt-4 text-right text-sm text-gray-500">
          — {{ testimonial.author }}
        </footer>
      </div>
    </div>
  </section>

  <!-- Shape Divider with CSS -->
  <div class="shape-divider bg-gray-600 py-10"></div>
</template>

<script setup>
const testimonials = [
  { message: "Ser paciente da Dra. Rose, no IOR, faz toda diferença. Ela tem um empenho, profissionalismo, honestidade com o tratamento e detalhes que fazem toda a diferença. Agradeço também a recepção e os auxiliares que sempre me orientam quando necessito. Super indico a clínica, Gratidão!", author: "Renata Fournier" },
  { message: "Realizei vários procedimentos na clínica IOR, desde limpeza até implante dentário. Achei os serviços maravilhosos, os profissionais muito disponíveis e muita variedade de especialidades. Avalio como muito positiva a minha experiência tanto no atendimento quanto no resultado do meu tratamento dentário que ficou incrível!", author: "Caroline Cunha" },
  { message: "É o sorriso que expressa nossa felicidade. Não posso deixar de compartilhar essa experiência inefável. Só tenho a agradecer ao IOR - Instituto de Odontologia Rodrigues, especialmente à Dra. Rose, excelente profissional e sempre comprometida profissionalmente.", author: "Valdemar Medeiros" },
  { message: "Excelente ambiente. Profissionais comprometidos e capacitados. É minha dentista há mais de 20 anos.", author: "Paulo Roberto" },
  { message: "Excelente atendimento! Os funcionários no geral são super profissionais, educados, simpáticos, atenciosos… simplesmente impecável! A Dr. Rose faz tudo com muito zelo, é bastante atenciosa e um amor de pessoa. Recomendo muito.", author: "Karol Kathleen" },
  { message: "Somos pacientes da Dra. Rose há vários anos e simplesmente super indicamos, profissionais de excelência! Cuida de toda a família com muita atenção e dedicação! Parabéns pelo trabalho.", author: "Marleide Leite" },
];
</script>

<style scoped>

</style>
